import { CompanyLinkType } from '@api';
import { useFormatAddress } from '@common';
import styles from './AddressCell.module.css';

type AddressCellProps = {
  address: CompanyLinkType['address'] | null;
};

export const AddressCell: React.FC<AddressCellProps> = ({ address }) => {
  const { formatAddressMultiLine } = useFormatAddress();
  if (!address) {
    return null;
  }

  return <div className={styles.addressCell}>{formatAddressMultiLine(address)}</div>;
};
